import styled from "styled-components";
import Title from "common/Typography/Title";
import { Diamond, GroupMedal } from "common/Icons/Icons";
import Flex from "common/Boxes/Flex";
import { CSSProperties } from "react";
import { hexToRGB } from "@shared/utils/misc";
import { phoneMinWidth } from "common/NewLook/layout.ts";

interface ScoreTagProps {
  score?: number;
  isTopTrader?: boolean;
  onClick?: () => void;
  setIsScoreHover?: (isScoreHover?: boolean) => void;
  style?: CSSProperties;
}

const ScoreTag = ({
  score,
  isTopTrader,
  onClick,
  setIsScoreHover,
  style,
}: ScoreTagProps) => {
  if (!score) return null;

  return (
    <Hover
      $isTopTrader={isTopTrader}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      style={{ cursor: onClick ? "pointer" : "auto", ...style }}
      onMouseEnter={() => setIsScoreHover?.(true)}
      onMouseLeave={() => setIsScoreHover?.(false)}
    >
      <TagBg $isTopTrader={isTopTrader}>
        {isTopTrader ? <MedalIcon /> : <DiamondIcon />}
        <Score level={4}>{Math.round(score * 100)}</Score>
      </TagBg>
    </Hover>
  );
};

export default ScoreTag;

const Hover = styled.div<{ $isTopTrader?: boolean }>`
  height: ${(p) => (p.$isTopTrader ? 35 : 33)}px;
  min-width: ${(p) => (p.$isTopTrader ? 74 : 56)}px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color linear 0.3s;
  @media (min-width: ${phoneMinWidth}) {
    &:hover {
      background: ${hexToRGB("#3272FE", 0.3)};
    }
  }
`;
const TagBg = styled(Flex)<{ $isTopTrader?: boolean }>`
  background: linear-gradient(117.02deg, #6abbfa 4.73%, #0f54e9 98.99%);
  border-radius: 50px;
  height: ${(p) => (p.$isTopTrader ? 25 : 23)}px;
  min-width: ${(p) => (p.$isTopTrader ? 64 : 46)}px;
  justify-content: ${(p) => (p.$isTopTrader ? "flex-end" : "center")};
  padding: ${(p) => (p.$isTopTrader ? "0 12px" : "0 6px")};
`;
const Score = styled(Title)`
  color: ${(p) => p.theme.colors.white};
  font-weight: ${(p) => p.theme.typography.fontWeights.SEMI_BOLD};
`;
const MedalIcon = styled(GroupMedal)`
  position: absolute;
  transform: translate(-19px, 2px);
  width: 40px;
  height: 40px;
`;
const DiamondIcon = styled(Diamond)`
  width: 13px;
  height: 13px;
  position: relative;
  margin-right: 2px;
`;
